<template>
    <div class="form-content-wrapper">
        <h6 class="form-title">DATA SURVEI</h6>
        <b-row no-gutters>
            <b-col cols="1">
                <label for="">1.</label>
            </b-col>
            <b-col>
                <label for="">Dari manakah nasabah mengetahui Pusat Gadai Indonesia ? </label>
                <b-form-radio-group class="radio-group" v-model="dataSurvey.surveyReferensi" name="surveyReferensi">
                    <div class="d-block" v-for="item in optSurveiReferensi"> 
                        <b-form-radio :value="item">
                            {{item}}
                        </b-form-radio>
                    </div>     
                </b-form-radio-group>
            </b-col>
        </b-row>
        <b-row no-gutters>
            <b-col cols="1">
                <label for="">2.</label>
            </b-col>
            <b-col>
                <label for="">Apakah Nasabah pernah gadai sebelumnya ? </label>
                <b-form-radio-group class="radio-group" v-model="dataSurvey.surveyPernahGadai" name="surveyPernahGadai">
                    <div class="d-block" v-for="item in optSurveiPernahGadai"> 
                        <b-form-radio :value="item">
                            {{item}}
                        </b-form-radio>
                    </div>     
                </b-form-radio-group>
            </b-col>
        </b-row>
        <b-row no-gutters>
            <b-col cols="1">
                <label for="">3.</label>
            </b-col>
            <b-col>
                <label for="">Jika pernah gadai mohon sebutkan dimana ? </label>
                <div class="d-block" > 
                <b-form-checkbox-group class="checkbox-group" name="referensi" stacked>
                        <b-form-checkbox v-model="dataSurvey.surveyKompetitor" v-for="item in optSurveyKompetitor" :value="item">
                            {{item}}
                        </b-form-checkbox>
                    </b-form-checkbox-group>
                    
                    <b-form-checkbox v-model="showLainnya" >
                        Lainnya <input v-if="showLainnya" v-model="inputLainnya" placeholder="Masukkan lainnya" />
                    </b-form-checkbox>
                </div>     
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'data-survey',
    props: {
        dataSurvey: { type: Object, required: true },
    },
    data(){
        return{
            optSurveiReferensi:[
                'Brosur',
                'Media Sosial (Instagram / Facebook)',
                'Banner / Lokasi langsung',
                'Rekomendasi Kerabat'
            ],
            optSurveiPernahGadai:[
                'Ya',
                'Tidak'
            ],
            optSurveyKompetitor:[
                'Pegadaian Hijau',
                'Raja Gadai',
                'KSP',
                'Indo Gadai',
                'Bijak Gadai',
            ],

            showLainnya: false,
            inputLainnya: "",
        }
    },
    watch: {
        "inputLainnya" : function(newVal , oldVal){
            this.dataSurvey.surveyKompetitor = this.dataSurvey.surveyKompetitor.filter(item => item != oldVal)
            if (newVal.trim() !== "") {
                this.dataSurvey.surveyKompetitor.push(newVal);
            }
        },
    },
    methods: {
        
      
    },
}
</script>
